import { hasOwnProperty } from 'vega-util';
import { keys } from './util';
/**
 * Data type based on level of measurement
 */
export var Type = {
  quantitative: 'quantitative',
  ordinal: 'ordinal',
  temporal: 'temporal',
  nominal: 'nominal',
  geojson: 'geojson'
};
export function isType(t) {
  return hasOwnProperty(Type, t);
}
export function isContinuous(type) {
  return type === 'quantitative' || type === 'temporal';
}
export function isDiscrete(type) {
  return type === 'ordinal' || type === 'nominal';
}
export var QUANTITATIVE = Type.quantitative;
export var ORDINAL = Type.ordinal;
export var TEMPORAL = Type.temporal;
export var NOMINAL = Type.nominal;
export var GEOJSON = Type.geojson;
export var TYPES = keys(Type);
/**
 * Get full, lowercase type name for a given type.
 * @param  type
 * @return Full type name.
 */
export function getFullName(type) {
  if (type) {
    type = type.toLowerCase();
    switch (type) {
      case 'q':
      case QUANTITATIVE:
        return 'quantitative';
      case 't':
      case TEMPORAL:
        return 'temporal';
      case 'o':
      case ORDINAL:
        return 'ordinal';
      case 'n':
      case NOMINAL:
        return 'nominal';
      case GEOJSON:
        return 'geojson';
    }
  }
  // If we get invalid input, return undefined type.
  return undefined;
}